import {compareValues} from '@ls/js-utils';
import Combobox from '@ls/react-combobox-grid';
import PropTypes from 'prop-types';
import React, {memo, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {
  selectFetchingSecurityAttributesOptions,
  selectSecurityAttributesOptions,
} from 'state/securityAttributes/selectors';
import {Cell, Grid} from 'styled-css-grid';

const SecurityAttributeComplication = ({setDefinition, definition}) => {
  const securityAttributesOptions = useSelector(selectSecurityAttributesOptions);
  const loading = useSelector(selectFetchingSecurityAttributesOptions);

  const options = useMemo(() => {
    return securityAttributesOptions?.map(value => ({label: value, value: value}))?.sort(compareValues('label')) ?? [];
  }, [securityAttributesOptions]);

  const [setAttribute] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setAttribute(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={1} gap="4px">
      <Cell>
        <Combobox
          options={options}
          onChange={setAttribute}
          isLoading={loading}
          value={definition.attribute}
          label="Attribute:"
          clearable
          variation={0}
          size={'S'}
          gridHeight={175}
        />
      </Cell>
    </Grid>
  );
};

SecurityAttributeComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(SecurityAttributeComplication);
